export default __webpack_public_path__ + "static/media/2112.90baaa67.png";